import React from "react";
import { ITabLabel, IChoice } from "./types";

const filters: Record<
  ITabLabel,
  { className: string; label: string; filter: (choice?: IChoice) => boolean }[]
> = {
  targets: [],
  conditions: [
    {
      label: "HP",
      className: "is-error",
      filter: choice => choice?.left === "hp"
    },
    {
      label: "Status",
      className: "is-success",
      filter: choice => choice?.left === "status"
    }
  ],
  actions: [
    {
      label: "Attack",
      className: "is-error",
      filter: choice => choice?.type === "attack"
    },
    {
      label: "Black Magic",
      className: "is-black",
      filter: choice => choice?.type === "magic" && choice?.subtype === "black"
    },
    {
      label: "White Magic",
      className: "",
      filter: choice => choice?.type === "magic" && choice?.subtype === "white"
    },
    {
      label: "Green Magic",
      className: "is-success",
      filter: choice => choice?.type === "magic" && choice?.subtype === "green"
    }
  ]
};

interface SelectionFilterProps {
  tab: ITabLabel;
  setFilter: React.Dispatch<React.SetStateAction<() => boolean>>;
}

export default function SelectionFilter({
  tab,
  setFilter
}: SelectionFilterProps) {
  return (
    <div className="selection-type-selector">
      {filters[tab].map(({ label, className, filter }) => (
        <button
          type="button"
          key={label}
          className={`nes-btn ${className}`}
          onClick={() => setFilter(() => filter)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
